// COMPONENTS
import * as ComponentLibrary from "@picnicmedia/masanatemples123";
// TYPES
import { CustomPackageState } from "../types";

interface Props {
  pkg: CustomPackageState | null;
}

/**
 * JH (30-07-26)
 * Right-column preview for the Custom flow: renders the staged package's blob URL in an iframe at its
 * native dimensions (scaled down to fit the column). Replaces DynamicFormatPreview when Custom is active.
 */
export function CustomPackagePreview({ pkg }: Props) {
  if (!pkg || !pkg.previewUrl) {
    return (
      <div className="flex flex-column justify-center items-center tc pa5" style={{ minHeight: "320px" }}>
        <ComponentLibrary.PCIconPicker icon={"file-zipper"} size={"2xl"} />
        <ComponentLibrary.PCSpacer type={"margin"} position={"top"} size={3} />
        <ComponentLibrary.PCLabel text={"Upload a package to see preview"} />
      </div>
    );
  }

  const width = pkg.inspection.width || 320;
  const height = pkg.inspection.height || 480;
  const scale = Math.min(1, 400 / width);

  return (
    <div style={{ width: `${width * scale}px`, height: `${height * scale}px`, overflow: "hidden", border: "1px solid #eee", borderRadius: "8px", background: "#fff" }}>
      <iframe title={"custom-package-preview"} src={pkg.previewUrl} width={width} height={height} scrolling={"no"} style={{ border: 0, transform: `scale(${scale})`, transformOrigin: "top left" }} />
    </div>
  );
}
